module.exports = __webpack_public_path__ + "img/orange_110.3c88c2f6.png";